import {PageService,MovieService,PreviewService} from 'hasta-la-vista-middleware-api/service'
import Vue from 'vue'

export default {
    name: 'events',
    data() {
        return {
            events: [],
            movieId: '',
            loading: true
        }
    },

    methods: {
        getContent() {
            this.loading = true


            Promise.all([PageService.getEvent(), MovieService.getMovies()]).then(([event, movie])=> {
                let events = []
                event.forEach((e)=> {
                    movie.data.forEach((m)=> {
                        if (m.id == e.related_movie) {
                            // Relate the info to event 
                            e.movie = m
                        }
                    })
                    events.push(e)
                })
                this.events = PreviewService.addPreviewToContentArrayIfAvailable('event',events);
                this.loading = false

                    // console.log(this.$parent.$el.previousSibling.offsetHeight)
                Vue.nextTick(() => {
                    if (this.$breakpoints.xs || this.$breakpoints.sm) {
                        window.scroll({top:0,left:0})
                        if (this.$parent.$el.offsetTop != undefined) {
                            window.scroll({
                                top: (this.$parent.$el.offsetTop - this.$parent.$el.previousSibling.offsetHeight),
                                left: 0,
                                behavior: 'smooth'
                            })
                        }
                    }
                })
            })

        }
    },

    mounted(){
        this.getContent()
    },
}



// WEBPACK FOOTER //
// ./src/components/exclusive-to-sk/events/events.js